<template>
  <div
    class="j-grid-item"
    :style="style"
  >
    <slot>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Number,
      required: true,
    },
    col: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      default: 1,
    },
    height: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    rowEnd() {
      return this.row + this.height
    },
    colEnd() {
      return this.col + this.width
    },
    style() {
      return {
        'grid-row-start': this.row,
        'grid-column-start': this.col,
        'grid-row-end': this.rowEnd,
        'grid-column-end': this.colEnd,
      }
    },
  },
}
</script>